import day from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
day.extend(advancedFormat);

import Wrapper from "../../assets/wrappers/Job";
import ScheduleInfo from "./ScheduleInfo.jsx"; // קומפ' קטנה להצגת אייקון+טקסט
import { FaClock, FaTrash, FaEdit } from "react-icons/fa";
import { BsArrowsFullscreen } from "react-icons/bs";
import { MdOutlineCreateNewFolder } from "react-icons/md";
import { Link, Form } from "react-router-dom";
import { customFetch } from "../../utils/custom-fetch";
import { toast } from "react-toastify";
import styled from "styled-components";
import { LiaHourglassStartSolid, LiaHourglassEndSolid } from "react-icons/lia";
import { TbReport } from "react-icons/tb";
import { ImEye } from "react-icons/im";
const CampaignThumbnail = styled.img`
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 5px;
  margin-right: 8px;
`;

const Schedule = ({
  _id,
  campaignId,
  buildings,
  startDate,
  endDate,
  timeSlots,
  isGlobal,
  screenType,
  createdAt,
  views = 0, // הוספתי ברירת מחדל ל-views
}) => {
  const start = day(startDate).format("DD.MM.YYYY");
  const end = day(endDate).format("DD.MM.YYYY");

  const creatre = day(createdAt).format("DD.MM.YYYY");
  const campaignImage = campaignId.media?.[0]?.url || "";
  const isVideo = campaignId.media?.[0]?.mediaType === "video";

  const handleDownloadReport = async () => {
    try {
      const response = await customFetch.get(
        `/campaign-schedules/${_id}/report`,
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "campaign_report.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      toast.error("שגיאה בהורדת הדוח");
    }
  };

  const handleDeleteSchedule = async () => {
    if (!window.confirm("להמשיך ולמחוק את התזמון?")) return;

    try {
      await customFetch.delete(`/campaign-schedules/${_id}`);
      toast.success("התזמון נמחק");
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } catch (err) {
      toast.error(err?.response?.data?.msg || "שגיאה במחיקה");
    }
  };
  return (
    <Wrapper>
      <header>
        <div>
          {isVideo ? (
            <img
              style={{ width: "80px" }}
              src="https://res.cloudinary.com/dlhfcdscf/image/upload/v1734522806/public/video_a7ri7d.png"
            />
          ) : (
            <CampaignThumbnail src={campaignImage} alt={`${name} Thumbnail`} />
          )}
        </div>
        <div className="info">
          <h5>{campaignId?.name}</h5>
          <p>{isGlobal ? "גלובלי" : `${buildings.length} בניינים`}</p>
        </div>
      </header>

      <div className="content">
        <div className="content-center">
          <ScheduleInfo icon={<LiaHourglassStartSolid />} text={`${start}`} />
          <ScheduleInfo icon={<LiaHourglassEndSolid />} text={`${end}`} />

          {timeSlots.map((t, idx) => (
            <ScheduleInfo
              key={idx}
              icon={<FaClock />}
              text={`${t.start}–${t.end}`}
            />
          ))}

          <ScheduleInfo text={screenType} icon={<BsArrowsFullscreen />} />
          <ScheduleInfo text={views} icon={<ImEye />} />
          <ScheduleInfo text={creatre} icon={<MdOutlineCreateNewFolder />} />
        </div>

        <footer className="actions" style={btnContainerStyle}>
          <div className="btn-container" style={btnContainerStyle}>
            <button
              type="button"
              className="btn btn-report"
              style={buttonStyle}
              onClick={handleDownloadReport}
            >
              <TbReport size={20} />
            </button>

            <Link
              to={`/dashboard/add-advertisement/${_id}`}
              className="btn btn-edit"
              style={buttonStyle}
            >
              <FaEdit size={20} />
            </Link>

            <button
              type="button"
              className="btn btn-delete"
              style={buttonStyle}
              onClick={handleDeleteSchedule}
            >
              <FaTrash size={20} />
            </button>
          </div>
        </footer>
      </div>
    </Wrapper>
  );
};

const btnContainerStyle = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "10px",
  margin: "10px",
};

const buttonStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "40px",
  height: "40px",
  backgroundColor: "#f0f0f0",
  borderRadius: "5px",
  color: "#333",
  textDecoration: "none",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  cursor: "pointer",
};

export default Schedule;
